import MiniButton from "./MiniButton";
export default MiniButton;